import {
  atom,
  selector,
} from 'recoil';


// metamask state
export const metamaskState = atom({
  key: 'metamask',
  default: {
    connected: false,
    address: '',
    network: '',
  },
});


// token state
export const tokenState = atom({
  key: 'token',
  default: {
    name: '',
    symbol: '',
    decimal: 18,
    supply: null,
    completed: false,
  },
});


// fees state
export const feesState = atom({
  key: 'fees',
  default: {
    amount: 0,
    currency: '',
    status: false,
    transactionHash: '',
  },
});

// contract state
export const contractState = atom({
  key: 'contract',
  default: {
    deployed: false,
    status: false,
    address: '',
    transactionHash: '',
  },
});





/*
  MetaMask Network IDs

  Mainnet: 1
  Kovan: 42
  Ropsten: 3
  Rinkeby: 4
  Goerli: 5
  Binance - 56


// web3 state
export const web3State = atom({
  key: 'web3',
  default: null,
});



*/


